import React, { useEffect, useState } from "react";
import useSnack from "../../hooks/useSnack";
import useApi from "../../hooks/useApi";
import { Link, useNavigate, useParams } from "react-router-dom";
import Footer from "../../components/footer";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
  tableCellClasses,
  useMediaQuery,
} from "@mui/material";
import ListingDetails from "../../components/ListingDetails";
import SnackAlert from "../../components/SnackAlert";
import SwiperImages from "../../components/SwiperImages";
import GlobalHeader from "../../components/header";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import { useTheme } from "@emotion/react";

function ActionButtons() {
  const params = useParams();
  return (
    <Stack
      component="section"
      flexDirection="row"
      gap={2}
      sx={{
        width: { xs: "85%", md: "100%" },
        marginInline: "auto",
        justifyContent: "right",
      }}
    ></Stack>
  );
}

function TableData({ data }) {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <>
      <Grid container spacing={2}>
        {(data || []).map((elementTable, index) => {
          return (
            <Grid item xs={12} md={6} key={index}>
              <TableContainer component={Paper} key={index} sx={{ mb: 2 }}>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      {(elementTable?.header || []).map((headerEl, index) => {
                        return (
                          <StyledTableCell
                            key={index}
                            width={index === 0 ? "50%" : "25%"}
                            sx={{ textAlign: index !== 0 ? "right" : "left" }}
                          >
                            {headerEl}
                          </StyledTableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {elementTable.body.map((row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell align="left">
                          {row.name}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.col1}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.col2}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}

const DesktopVersion = ({ detailData, tableInfo, stadisticsData }) => {
  const transformData = (data) => {
    const result = [];

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const header = key
          .replace("_", " ")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        const body = data[key].map((item) => ({
          name: item.name,
          col1: "",
          col2: parseInt(item.value).toLocaleString("es-CO"),
        }));

        result.push({
          header: [header, "", ""],
          body: body,
        });
      }
    }

    return result;
  };

  let tempData = [];

  tempData = transformData(stadisticsData);

  if (tempData.length !== 0) {
    tempData[0].header = ["Gastos", "", ""];
    tempData[1].header = ["Año", "", ""];

    if (tempData[0].body.length === 0) {
      tempData[0].body = [
        { name: "Sin datos por el momento", col1: "", col2: "" },
      ];
    }
    if (tempData[1].body.length === 0) {
      tempData[1].body = [
        { name: "Sin datos por el momento", col1: "", col2: "" },
      ];
    }
  }
  return (
    <>
      <Stack component="section" mb={4} mt={{ xs: 3, lg: 6 }}>
        <Typography component="h3" variant="h5">
          ¿Qué es {detailData.name}?
        </Typography>
        <Typography mt={2} fontWeight="normal">
          {detailData.information}
        </Typography>
      </Stack>
      <Stack mb={4}>
        <SwiperImages data={detailData.gallery} slides={3} />
      </Stack>
      <Stack mb={4}>
        <TableData data={tableInfo} />
      </Stack>
      <Stack component="section">
        <Typography component="h3" variant="h5" textAlign="center" mb={1}>
          Seguimiento detallado
        </Typography>
        <Box mb={3} sx={{ width: "70%", marginInline: "auto" }}>
          <Divider orientation="horizontal" />
        </Box>
        <Stack>
          <TableData data={tempData} />
        </Stack>
      </Stack>
    </>
  );
};

const MobileVersion = ({ detailData, tableInfo, stadisticsData }) => {
  const [selectedButton, setSelectedButton] = useState("information");
  const transformData = (data) => {
    const result = [];

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const header = key
          .replace("_", " ")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        const body = data[key].map((item) => ({
          name: item.name,
          col1: "",
          col2: parseInt(item.value).toLocaleString("es-CO"),
        }));

        result.push({
          header: [header, "", ""],
          body: body,
        });
      }
    }

    return result;
  };

  let tempData = [];

  tempData = transformData(stadisticsData);

  if (tempData.length !== 0) {
    tempData[0].header = ["Gastos", "", ""];
    tempData[1].header = ["Año", "", ""];

    if (tempData[0].body.length === 0) {
      tempData[0].body = [
        { name: "Sin datos por el momento", col1: "", col2: "" },
      ];
    }
    if (tempData[1].body.length === 0) {
      tempData[1].body = [
        { name: "Sin datos por el momento", col1: "", col2: "" },
      ];
    }
  }

  return (
    <>
      <Stack
        sx={{
          backgroundColor: "primary.300",
          borderRadius: 2,
          mt: 4,
          mb: 4,
        }}
      >
        <Grid container>
          <Grid item xs={4}>
            <Button
              onClick={() => setSelectedButton("information")}
              sx={{
                borderRadius: 2,
                p: 2,
                color: "white",
                backgroundColor:
                  selectedButton === "information" ? "primary.lighter" : "none",
              }}
              fullWidth
            >
              Información
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              onClick={() => setSelectedButton("gallery")}
              sx={{
                borderRadius: 2,
                p: 2,
                color: "white",
                backgroundColor:
                  selectedButton === "gallery" ? "primary.lighter" : "none",
              }}
              fullWidth
            >
              Galería
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              onClick={() => setSelectedButton("metrics")}
              sx={{
                borderRadius: 2,
                p: 2,
                color: "white",
                backgroundColor:
                  selectedButton === "metrics" ? "primary.lighter" : "none",
              }}
              fullWidth
            >
              Métricas
            </Button>
          </Grid>
        </Grid>
      </Stack>
      {selectedButton === "information" ? (
        <Stack component="section" mb={3}>
          <Typography component="h3" variant="h5">
            ¿Qué es {detailData.name}?
          </Typography>
          <Typography mt={2} fontWeight="normal">
            {detailData.information}
          </Typography>
        </Stack>
      ) : selectedButton === "gallery" ? (
        <Stack mb={3}>
          <SwiperImages data={detailData.gallery} slides={1} />
        </Stack>
      ) : (
        <>
          <Stack mb={3}>
            <TableData data={tableInfo} />
          </Stack>
          <Stack component="section">
            <Typography component="h3" variant="h5" textAlign="center" mb={1}>
              Seguimiento detallado
            </Typography>
            <Box mb={2} sx={{ width: "70%", marginInline: "auto" }}>
              <Divider orientation="horizontal" />
            </Box>
            <Stack>
              <TableData data={tempData} />
            </Stack>
          </Stack>
        </>
      )}
      <ActionButtons />
    </>
  );
};

const RenderedSection = ({
  detailData,
  listData,
  tableInfo,
  stadisticsData,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack>
      <Box sx={{ width: "100%", height: { xs: 320, md: 400 } }}>
        <img
          src={detailData.photo_profile.url}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>
      <Stack px={{ xs: 2, md: 4 }}>
        <Stack component="section" pt={5}>
          <Typography component="h2" variant="h5" mb={2}>
            {detailData.name}
          </Typography>
          <Typography
            component="span"
            sx={{
              backgroundColor: "secondary.typePropertySpan",
              width: "fit-content",
              px: 2,
              py: 0.5,
              borderRadius: 3,
              mb: 5,
              fontWeight: "normal",
            }}
          >
            {detailData.name_business}
          </Typography>
          {/* <ListingDetails data={listData} /> */}
          <Stack>
            <Grid container spacing={2}>
              {(listData || []).map((detailData, index) => {
                return (
                  <Grid item xs={6} md={4} key={index}>
                    <Box
                      sx={{
                        boxShadow: "2px 3px 5px #7d7d7d24",
                        borderRadius: 2,
                        p: 2,
                      }}
                    >
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={2}
                        mb={1}
                      >
                        <detailData.icon
                          sx={{
                            color: "gray",
                            backgroundColor: "#F3F4F6",
                            p: 1,
                            borderRadius: "50%",
                          }}
                        />
                        <Typography
                          component="h3"
                          variant="subtitle1"
                          fontWeight={400}
                          color="#303030ed"
                        >
                          {detailData.title}
                        </Typography>
                      </Box>
                      <Typography component="span" fontFamily={"sans-serif"}>
                        {detailData.value}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Stack>
        </Stack>
        <Stack mt={6}>
          <Typography component="h3" variant="h5" mb={2}>
            Progreso del proyecto
          </Typography>
          <Stack flexDirection="row" justifyContent="space-between" mb={1}>
            <Typography
              fontWeight="normal"
              display={"flex"}
              alignItems={"center"}
              gap={1}
              fontSize={{ xs: "small", md: "large" }}
            >
              Invertidos:{" "}
              <Typography fontWeight={700}>
                {parseInt(detailData.invested).toLocaleString("es-CO")}€
              </Typography>
            </Typography>
            <Typography
              fontWeight="normal"
              display={"flex"}
              alignItems={"center"}
              gap={1}
              fontSize={{ xs: "small", md: "large" }}
            >
              Objetivo:{" "}
              <Typography fontWeight={700}>
                {parseInt(detailData.objective).toLocaleString("es-CO")}€
              </Typography>
            </Typography>
          </Stack>
          <LinearProgress
            variant="determinate"
            value={
              parseInt(detailData.completed) > 100
                ? 100
                : parseInt(detailData.completed)
            }
            sx={{ height: "10px", fill: "primary.300", borderRadius: 1 }}
          />
        </Stack>
        {isSmallScreen ? (
          <MobileVersion
            detailData={detailData}
            tableInfo={tableInfo}
            stadisticsData={stadisticsData}
          />
        ) : (
          <DesktopVersion
            detailData={detailData}
            tableInfo={tableInfo}
            stadisticsData={stadisticsData}
          />
        )}
      </Stack>
    </Stack>
  );
};

function InvestedProject() {
  // GET DETAILS REQUEST
  const params = useParams();

  const navigate = useNavigate();

  const GetDetails = async () => {
    setOpenBackDrop(true);

    loadApi(`project/project/${params.id}`, true, "get")
      .then((response) => {
        const dataMapping = {
          "Ticket Minimo":
            parseInt(response.data.min_investment).toLocaleString("es-ES") +
            "Є",
          Invertidos: parseInt(response.data.invested).toLocaleString("es-ES"),
          Rentabilidad:
            parseInt(response.data.esti_profitability).toLocaleString("es-ES") +
            "%",
          Completado: response.data.completed + "%",
          Inversores: response.data.cant_investors,
          "Días Restantes": response.data.remainingDays,
          Objetivo:
            parseInt(response.data.objective).toLocaleString("es-CO") + "Є",
        };
        const updatedListData = listData.map((item) => ({
          ...item,
          value: dataMapping[item.title] || item.value,
        }));

        const updatedTableInfo = [
          {
            header: ["Inversión", "MIN", "MAX"],
            body: [
              {
                name: "Capital Ofrecido",
                col1: parseInt(
                  response.data.min_offered_capital
                ).toLocaleString("es-CO"),
                col2: parseInt(
                  response.data.max_offered_capital
                ).toLocaleString("es-CO"),
              },
              {
                name: "Participaciones a emitir",
                col1: response.data.min_stake,
                col2: response.data.max_stake,
              },
              {
                name: "Valor por participación",
                col1: parseInt(response.data.min_investment).toLocaleString(
                  "es-CO"
                ),
                col2: parseInt(response.data.objective).toLocaleString("es-CO"),
              },
            ],
          },
          {
            header: ["Rentabilidad Estimada", "MIN", "MAX"],
            body: [
              {
                name: "Retorno de inversión",
                col1: parseInt(
                  response.data.min_return_investment
                ).toLocaleString("es-CO"),
                col2: parseInt(
                  response.data.max_return_investment
                ).toLocaleString("es-CO"),
              },
              {
                name: "Rentabilidad recursos propios",
                col1: parseInt(response.data.esti_profitability).toLocaleString(
                  "es-CO"
                ),
                col2: parseInt(response.data.objective).toLocaleString("es-CO"),
              },
              {
                name: "Punto muerto",
                col1: response.data.deadpoint,
                col2: response.data.deadpoint,
              },
            ],
          },
          {
            header: ["Destino Inversión", "MIN", "MAX"],
            body: [
              {
                name: "Marketing",
                col1: parseInt(response.data.min_marketing).toLocaleString(
                  "es-CO"
                ),
                col2: parseInt(response.data.max_marketing).toLocaleString(
                  "es-CO"
                ),
              },
              {
                name: "Construcción",
                col1: parseInt(response.data.min_construction).toLocaleString(
                  "es-CO"
                ),
                col2: parseInt(response.data.max_construction).toLocaleString(
                  "es-CO"
                ),
              },
            ],
          },
          {
            header: ["Garantías", "", ""],
            body: [
              {
                name: "Inmobiliaria",
                col1: " ",
                col2: " ",
              },
              {
                name: "Económica",
                col1: " ",
                col2: " ",
              },
            ],
          },
        ];

        loadApi("bills/follow_up/" + params.id, true, "get")
          .then((response) => {
            setStadisticsData(response.data);
          })
          .catch((e) => {
            showSnack(e.message);
          });

        setTableInfo(updatedTableInfo);

        setListData(updatedListData);
        setDetailData(response.data);
      })
      .catch((e) => {
        navigate("/me/investments");
      })
      .finally(() => setOpenBackDrop(false));
  };

  // DATA
  const [detailData, setDetailData] = useState(false);
  const [listData, setListData] = useState([
    {
      title: "Ticket Minimo",
      icon: LocalActivityIcon,
      value: "",
    },
    {
      title: "Invertidos",
      icon: LocalAtmIcon,
      value: "",
    },
    {
      title: "Rentabilidad",
      icon: AutoGraphIcon,
      value: "",
    },
    {
      title: "Inversores",
      icon: PersonOutlineOutlinedIcon,
      value: "",
    },
    {
      title: "Días Restantes",
      icon: WatchLaterOutlinedIcon,
      value: "",
    },
    {
      title: "Objetivo",
      icon: StarOutlinedIcon,
      value: "",
    },
  ]);
  const [tableInfo, setTableInfo] = useState(false);
  const [stadisticsData, setStadisticsData] = useState(false);

  // UTILS
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    GetDetails();
  }, []);

  return (
    <>
      <GlobalHeader />
      <Stack
        component="main"
        sx={{
          minHeight: "90vh",
          width: { xs: "100vw", sm: "90vw", md: "85vw", lg: "65vw" },
          marginInline: "auto",
          pb: 4,
          backgroundColor: "white",
        }}
      >
        {detailData && (
          <>
            {/* IF THE ARRAY IS EMPTY THIS WILL BE SHOW IT */}
            {detailData.error && (
              <Stack sx={{ mt: 10 }}>
                <Typography textAlign="center" variant="h5">
                  Lo sentimos, datos no encontrados
                </Typography>
              </Stack>
            )}
            {/* IN CASE THAT THE ERROR KEY DOESNT EXIST, THE DATA IS RENDERED */}
            {!detailData.error && stadisticsData ? (
              <RenderedSection
                stadisticsData={stadisticsData}
                detailData={detailData}
                listData={listData}
                tableInfo={tableInfo}
              />
            ) : (
              ""
            )}
          </>
        )}
      </Stack>
      <Footer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default InvestedProject;
